/**
 * La pestaña activa, a la vista · 12-10-2026
 *
 * En el móvil las pestañas de cada sección se deslizan en una sola fila en vez de
 * apilarse en tres (`tema.css`, `.pestañas`). Al entrar en una pantalla, su pestaña
 * se trae a la vista: sin esto, abrir «Devoluciones» la dejaba fuera, a la
 * derecha, y no se veía en qué pantalla se estaba.
 *
 * `block: 'nearest'` para no mover la página en vertical: la pestaña ya está
 * arriba. En escritorio no hay nada que deslizar y no hace nada.
 */
import { useEffect } from 'react';
import { useRouterState } from '@tanstack/react-router';

export function usePestanaActivaALaVista(): void {
  const camino = useRouterState({ select: (s) => s.location.pathname });

  useEffect(() => {
    const id = requestAnimationFrame(() => {
      for (const pestana of document.querySelectorAll(
        '.pestañas .pestaña-activa'
      )) {
        pestana.scrollIntoView({ block: 'nearest', inline: 'center' });
      }
    });
    return () => cancelAnimationFrame(id);
  }, [camino]);
}
